<div class="tileType">
    <div class="pie-chart-style" [class.active]="active == visualizationType.PIE_CHART"
        (dblclick)="dblClickIcon(visualizationType.PIE_CHART)" (click)="selectChart(visualizationType.PIE_CHART)">
        <smart-icon name="pie-chart"></smart-icon>
        <span class="body-1">PIE CHART</span>
    </div>
    <div class="bar-chart-style" [class.active]="active == visualizationType.COLUMN_CHART"
        (dblclick)="dblClickIcon(visualizationType.COLUMN_CHART)" (click)="selectChart(visualizationType.COLUMN_CHART)">
        <smart-icon name="column-chart"></smart-icon>
        <span class="body-1">COLUMN CHART</span>
    </div>
    <div class="line-chart-style" [class.active]="active == visualizationType.LINE_CHART"
        (dblclick)="dblClickIcon(visualizationType.LINE_CHART)" (click)="selectChart(visualizationType.LINE_CHART)">
        <smart-icon name="line-chart"></smart-icon>
        <span class="body-1">LINE CHART</span>
    </div>
    <div class="number-tile-style" [class.active]="active == visualizationType.VALUE"
        (dblclick)="dblClickIcon(visualizationType.VALUE)" (click)="selectChart(visualizationType.VALUE)">
        <smart-icon name="value-tile"></smart-icon>
        <span class="body-1">VALUE TILE</span>
    </div>
    <div class="properties-tile-style" [class.active]="active == visualizationType.METADATA"
        (dblclick)="dblClickIcon(visualizationType.METADATA)" (click)="selectChart(visualizationType.METADATA)">
        <smart-icon name="properties-tile"></smart-icon>
        <span class="body-1">PROPERTIES TILE</span>
    </div>
    <div class="grid-style" [class.active]="active == visualizationType.GRID"
        (dblclick)="dblClickIcon(visualizationType.GRID)" (click)="selectChart(visualizationType.GRID)">
        <smart-icon name="grid-tile"></smart-icon>
        <span class="body-1">GRID</span>
    </div>
    <div class="bar-chart-style" [class.active]="active == visualizationType.BAR_CHART"
        (dblclick)="dblClickIcon(visualizationType.BAR_CHART)" (click)="selectChart(visualizationType.BAR_CHART)">
        <smart-icon name="bar-chart"></smart-icon>
        <span class="body-1">BAR CHART</span>
    </div>
    <div class="note-style" [class.active]="active == visualizationType.NOTES"
        (dblclick)="dblClickIcon(visualizationType.NOTES)" (click)="selectChart(visualizationType.NOTES)">
        <smart-icon name="note-tile"></smart-icon>
        <span class="body-1">NOTE TILE</span>
    </div>
    <div class="note-style" [class.active]="active == visualizationType.EDITOR"
        (dblclick)="dblClickIcon(visualizationType.EDITOR)" (click)="selectChart(visualizationType.EDITOR)">
        <smart-icon name="textarea-tile"></smart-icon>
        <span class="body-1">TEXTAREA TILE</span>
    </div>
    <div *ngIf="isMapTileEnabled" class="note-style" [class.active]="active == visualizationType.MAP"
        (dblclick)="dblClickIcon(visualizationType.MAP)" (click)="selectChart(visualizationType.MAP)">
        <smart-icon name="map-tile"></smart-icon>
        <span class="body-1">MAP TILE</span>
    </div>
</div>